module.exports = __webpack_public_path__ + "img/i18a.25d4d0d0.svg";